import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { Tooltip } from '@mui/material'
import theme from 'theme'

export const ChipTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: `${theme.attributes.borderRadius.tertiary}`,
    background: theme.colors.legacyPrimaryLight2,
    border: `1px solid ${theme.colors.menuItemHover}`,
    boxShadow: theme.colors.tooltipShadow,
    display: 'flex',
    padding: `${theme.spacing.md}px`,
    width: '100%',
    maxWidth: '275px',
    overflowY: 'auto'
  },
  '.tooltip-text': {
    color: theme.colors.menuItemText,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.large,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeight.normal,
    letterSpacing: '0.25px'
  },
  '.note-wrapper': {
    marginTop: `${theme.spacing.xSmall}px`,

    '.note-text': {
      color: theme.colors.calendarDay,
      fontFamily: theme.typography.fontFamily.primary,
      fontSize: theme.typography.fontSize.large,
      fontStyle: 'normal',
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '140%',
      wordBreak: 'break-all'
    }
  },
  '.tooltip-header-ssm': {
    color: theme.colors.menuItemText,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.medium,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: '140%'
  },
  '.tooltip-text-ssm': {
    color: '#A88CA4',
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.medium,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: '140%'
  }
})
